import { useState } from "react";
import { Dialog, DialogContent, DialogDescription, DialogTitle } from "@/components/ui/dialog";
import { api, loginWithGoogle } from "@/auth";

const COPY = {
  login: "A secret. Log in with Google and donate 50p to unlock memory.",
  donate: "Donate 50p to unlock memory for good.",
  checking: "Checking your donation…",
  thanks: "Thank you. Memory is unlocked. Type it again.",
  failed: "The donation didn't go through. You can try again.",
};

export const SecretGate = ({ state, onOpenChange, user }) => {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(false);
  const step = state === "locked" ? (user ? "donate" : "login") : state;

  const donate = async () => {
    setBusy(true);
    setError(false);
    const r = await api("/payments/checkout", { method: "POST", body: JSON.stringify({ origin_url: window.location.origin }) }).catch(() => null);
    const d = r && r.ok ? await r.json() : null;
    if (d?.checkout_url) window.location.href = d.checkout_url;
    else { setBusy(false); setError(true); }
  };

  return (
    <Dialog open={!!state} onOpenChange={onOpenChange}>
      <DialogContent className="story-dialog gate-dialog" data-testid="secret-gate-dialog" data-step={step}>
        <DialogTitle className="sr-only">Unlock secrets</DialogTitle>
        <DialogDescription className="gate-text" data-testid="secret-gate-text">{COPY[step]}</DialogDescription>
        {step === "login" && (
          <button className="gate-btn" onClick={loginWithGoogle} data-testid="gate-login-button">Log in with Google</button>
        )}
        {(step === "donate" || step === "failed") && (
          <button className="gate-btn" onClick={donate} disabled={busy} data-testid="gate-donate-button">{busy ? "Opening Stripe…" : "Donate 50p"}</button>
        )}
        {error && <p className="gate-error" data-testid="secret-gate-error">Couldn't open Stripe. Please try again.</p>}
      </DialogContent>
    </Dialog>
  );
};
